<template>
    <div class="mt-1 mx-0">
        <v-row class="mb-3 mt-1">
            <v-col lg=3 sm=6 cols=12>
                <v-card class="card-style px-1 mb-3" outlined elevation="2" height="100">
                    <v-card-title class="d-flex flex-nowrap pa-0 justify-center">
                        <p class="text-h5 text-truncate mb-3 mr-2">{{ $t('marketSentiment.now.title') }}</p>
                        <v-tooltip bottom open-on-click max-width="180">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" icon color="grey" class="mb-3" size="10">
                                    <v-icon size="15">mdi-help-circle</v-icon>
                                </div>
                            </template>
                            <span style="justify-content: center !important">{{ $t('marketSentiment.now.help') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text class="px-5 pt-4 mt-2">
                        <v-row>
                            <v-progress-linear
                                :value=sentimentData.now
                                background-color="#ececec"
                                :color="getSentimentColor(sentimentData.now)"
                            ></v-progress-linear>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="card-style px-1 mb-3" outlined elevation="2" height="100">
                    <v-card-title class="d-flex flex-nowrap pa-0 justify-center">
                        <p class="text-h5 text-truncate mb-3 mr-2">{{ $t('marketSentiment.today.title') }}</p>
                        <v-tooltip bottom open-on-click max-width="180">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" icon color="grey" class="mb-3" size="10">
                                    <v-icon size="15">mdi-help-circle</v-icon>
                                </div>
                            </template>
                            <span style="justify-content: center !important">{{ $t('marketSentiment.today.help') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text class="px-5 pt-4 mt-2">
                        <v-row>
                            <v-progress-linear
                                :value=sentimentData.today
                                background-color="#ececec"
                                :color="getSentimentColor(sentimentData.today)"
                            ></v-progress-linear>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="card-style px-1 mb-3" outlined elevation="2" height="100">
                    <v-card-title class="d-flex flex-nowrap pa-0 justify-center">
                        <p class="text-h5 text-truncate mb-3 mr-2">{{ $t('marketSentiment.week.title') }}</p>
                        <v-tooltip bottom open-on-click max-width="180">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" icon color="grey" class="mb-3" size="10">
                                    <v-icon size="15">mdi-help-circle</v-icon>
                                </div>
                            </template>
                            <span style="justify-content: center !important">{{ $t('marketSentiment.week.help') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text class="px-5 pt-4 mt-2">
                        <v-row>
                            <v-progress-linear
                                :value=sentimentData.week
                                background-color="#ececec"
                                :color="getSentimentColor(sentimentData.week)"
                            ></v-progress-linear>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card class="card-style px-1 mb-3" outlined elevation="2" height="100">
                    <v-card-title class="d-flex flex-nowrap pa-0 justify-center">
                        <p class="text-h5 text-truncate mb-3 mr-2">{{ $t('marketSentiment.month.title') }}</p>
                        <v-tooltip bottom open-on-click max-width="180">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" icon color="grey" class="mb-3" size="10">
                                    <v-icon size="15">mdi-help-circle</v-icon>
                                </div>
                            </template>
                            <span style="justify-content: center !important">{{ $t('marketSentiment.month.help') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text class="px-5 pt-4 mt-2">
                        <v-row>
                            <v-progress-linear
                                :value=sentimentData.month
                                background-color="#ececec"
                                :color="getSentimentColor(sentimentData.month)"
                            ></v-progress-linear>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="9">
                <v-card class="card-style px-0 pb-0 mx-1 mb-1" outlined elevation="2" height="650">
                    <v-card-title class="px-5 mx-5 pb-3">
                        <p>{{ $t('marketSentiment.evolutionChart.title') }}</p>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom open-on-click max-width="180">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" icon color="grey" class="mr-2" size="10">
                                    <v-icon size="15">mdi-help-circle</v-icon>
                                </div>
                            </template>
                            <span style="justify-content: center !important">{{ $t('marketSentiment.evolutionChart.help') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text class="pa-5 pt-0 pb-0">
                        <v-row no-gutters>
                            <v-col cols="12" class="my-auto">
                                <ApexChart type="line" height="550" :options="getChartOptions"
                                    :series="sentimentData.history">
                                </ApexChart>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import ApexChart from 'vue-apexcharts';
import chartsConfig from './charts-config';

import { UtilsMixin } from '@/mixins/utils';

export default {
    components: {
        ApexChart
    },
    mixins: [
        UtilsMixin
    ],
    data() {
        return {
            chartsConfig,
            sentimentData: {
                now: 50,
                today: 30,
                week: 70,
                month: 90,
                history: [
                    {
                        name: this.$t('marketSentiment.evolutionChart.item.daily'),
                        data: [50, 55, 60, 40, 35, 50, 59, 67, 88, 92, 78, 65]
                    },
                    {
                        name: this.$t('marketSentiment.evolutionChart.item.weekly'),
                        data: [55, 56, 68, 36, 45, 58, 64, 78, 85, 81, 84, 87]
                    },
                    {
                        name: this.$t('marketSentiment.evolutionChart.item.monthly'),
                        data: [49, 28, 62, 43, 36, 55, 65, 70, 84, 85, 70, 60]
                    }
                ]
            }
        };
    },
    computed: {
        getChartOptions() {
            let options = chartsConfig.linesGraph.options;
            options.xaxis.categories = ['11/10', '18/10', '25/10', '01/11', '08/11', '15/11', '22/11', '29/11', '06/12', '13/12', '20/12', '27/12'];
            return options;
        },
    },
};
</script>

<style scoped>
</style>